<!--
    参数格式

list        非必填          [{name:展示名称,type:跳转路由}]

bgColor     非必填          "#ff"  -   背景颜色

<slot name="logo-wrap">     插槽 控制logo 和 tab
<slot name="tab-wrap">

-->

<template>
  <div class="container">
    <div class="header" :style="styleObject">
      <div class="main w">
        <div class="left">
          <slot name="logo-wrap">
            <h1 class="logo-wrap">
              <div class="img-wrap">
                <img class="img" :src="pcLogo" alt="厦门市大学生创业与产教融合促进会logo" />
              </div>
            </h1>
          </slot>
          <slot name="searchAll">
            <div class="searchBlock">
              <div class="input-block">
                <input v-model="searchKey" type="text" @change="searchChange" class="input" placeholder="在此输入关键字" />
              </div>
              <div class="search-btn" @click="searchChange">
                <span class="icon iconfont icon-search"></span>
              </div>
            </div>
          </slot>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="navBlock">
      <div class="nav-list w">
        <div class="nav-item" v-for="(item, index) in navList" :key="index" :class="{'nav-active':item.categoryCode == currentCode}">
          <div class="nav-content" @click="handleEnter(item, item.categoryCode)">

            {{ item.categoryName }}
          </div>
          <ul class="submenu">
            <li v-for="(t, i) in item.list" :key="i" @click="handleEnter(t, item.categoryCode)">
              {{ t.categoryName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavList } from "@/api/common/common";
export default {
  props: ["list", "word"],
  data() {
    return {
      pcLogo: this.$globalHeader.fileUrl + "/static/xmdch/yx/logo_3.png",
      searchKey: "", //搜索内容

      navList: [],
      currentCode: ''
    };
  },
  computed: {
    styleObject() {
      return {
        backgroundImage: `url(${this.$globalHeader.fileUrl}/static/xmdch/yx/1_1.png)`,
      };
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.searchKey = this.word
      getNavList().then((res) => {
        this.navList = res.data;

        let home = {
          categoryCode: '',
          icon: "icon-home",
          categoryName: "首页",
          linkUrl: "home",
        };
        this.navList.unshift(home);

      });
    },
    searchChange() {
      console.log("回车事件this.searchKey", this.searchKey);
      if (!this.searchKey || this.searchKey == '') return
      //搜索结果页面
      this.$router.push({
        path: "/searchPage/searchResult",
        query: {
          keyWord: this.searchKey,
        },
      });
    },
    //快速跳转
    handleEnter(item, tabcode) {

      this.currentCode = tabcode
      // console.log("item.linkUrl ", item,tabcode);
      if (item.linkUrl == "home") {
        this.$router.push("/");
      } else {
        if (item.list && item.list.length) {
          item = item.list[0];
          console.log("item.list[0]", item, item.linkUrl);
        }

        let baseUrl =
          "/newsList?categoryId=" +
          item.categoryCode +
          "&linkType=" +
          item.linkType +
          "&tabcode=" +
          tabcode +
          "&seccode=" +
          item.categoryCode;
        let coopUrl =
          "/cooperateUnit/list?categoryId=" +
          item.categoryCode +
          "&linkType=" +
          item.linkType +
          "&tabcode=" +
          tabcode +
          "&seccode=" +
          item.categoryCode;
        let singleImage =
          "/singleImage?categoryId=" +
          item.categoryCode +
          "&linkType=" +
          item.linkType +
          "&tabcode=" +
          tabcode +
          "&seccode=" +
          item.categoryCode;

        let url = "";
        switch (item.linkType) {
          case "1":
            url = baseUrl;
            break;
          case "2":
            url = baseUrl;
            break;
          case "3":
            url = coopUrl;
            break;
          case "4":
            url = singleImage;
            break;
          default:
            baseUrl;
        }
        url = item.linkUrl || item.url != null ? url + "&id=" + item.linkUrl : url
        console.log("url", url);
        window.location.href = url;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background-size: 100% 100%;
  height: 100px;
  display: flex;
  align-items: center;
  .max {
    width: 1400px;
    margin: 0 auto;
  }
  .main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 200px;

    .left {
      flex-shrink: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .logo-wrap {
        padding: 0;
        margin: 0;
        line-height: 1;
        display: flex;
        align-items: center;
        // margin-right: 6%;

        .img-wrap {
          margin-right: 20px;
          width: 420px; /* 缩小宽度 */
          height: auto; /* 高度自动，保持比例 */
        }

        .title {
          margin-left: 12px;
          font-size: 20px;
        }
      }

      .split-line {
        width: 1px;
        height: 40px;
        transform: translate(-20px, 0);
        background-color: #f1f1f1;
      }
      .searchBlock {
        display: flex;
        height: 44px;
        color: #c2c2c2;
        color: #333;
        font-size: 16px;
        .input-block {
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e6e6e6;
          color: #333;
          .tag {
            margin: 12px 6px;
            padding: 0 15px;
          }
          .icon {
            font-size: 17px;
            margin-right: 0.5em;
          }
          .input {
            color: #353535;
            width: 350px;
            padding-left: 12px;
          }
          .input::placeholder {
            color: #333;
          }
        }
        .search-btn {
          width: 70px;
          font-size: 18px;
          background: #005495;
          color: #fff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          .icon {
            font-size: 18px;
          }
        }
        .lables {
          display: flex;
          justify-content: space-around;
          color: #999;
          font-size: 16px;
          cursor: pointer;
          .item {
            padding: 20px 10px;
          }
          // .item:first-child {
          //   margin-left: 0;
          // }
          // .item:last-child {
          //   margin-right: 0;
          // }
        }
      }
      .list {
        height: 100%;
        display: flex;
        align-items: center;

        .item {
          position: relative;
          height: 100%;
          line-height: 100px;
          padding: 0 28px;
          font-size: 20px;
          cursor: pointer;
        }

        .item:hover {
          color: #2d7cce;
        }

        .active {
          color: #2d7cce;
        }

        .active::after {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 20px;
          transform: translate(-50%, 0);
          width: calc(100% - 56px);
          height: 3px;
          border-radius: 2px;
          background-color: #2d7cce;
          overflow: hidden;
        }
      }
    }

    .right {
      flex-shrink: 0;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 10px 0;
      padding: 6px 12px;
      // border: 1px solid #f2f2f2;
      cursor: pointer;
      border-radius: 3px;
      .img-wrap {
        width: 70px;
        height: 70px;
        // border-radius: 50%;
        overflow: hidden;
        background-color: #fff;
        padding: 4px;
        border-radius: 6px;
      }

      .r-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // margin-left: 12px;
        margin-top: 0.3em;
        .title {
          font-size: 15px;
          font-weight: bold;
          color: #000;
        }

        .subtitle {
          font-size: 16px;
          color: #597af8;
        }
      }

      .right-box {
        border-radius: 3px 0 3px 3px;
        box-sizing: border-box;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        padding: 12px 24px;
        top: 52px;
        right: 0;
        background-color: #fff;
        border: 1px solid #f2f2f2;
        box-shadow: 0 2px 2px rgba($color: #000000, $alpha: 0.05);
        z-index: 10;

        .img-wrap {
          width: 160px;
          height: 160px;
          overflow: hidden;
          border-radius: 0;
        }

        span {
          padding: 10px 0;
          font-size: 14px;
        }
      }
    }

    .right:hover {
      .right-box {
        display: flex;
      }
    }
  }
}
.navBlock {
  background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);

  .nav-list {
    display: flex;
    align-items: center;

    justify-content: space-between;
  }
  .icon {
    margin-right: 0.2em;
  }
  .nav-item {
    cursor: pointer;
    min-width: 120px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    display: inline-block;
    position: relative;
    z-index: 99;
    .nav-content {
      height: 50px;
      line-height: 50px;
    }
  }
  .nav-item:hover {
    background: #d53b35;
  }
  // .nav-active {
  //   background: #d53b35;
  // }
  li {
    list-style: none;
    line-height: 50px;
    width: 120px;
  }
  .submenu {
    position: absolute;
    top: 50px;
    max-height: 0;
    overflow: hidden;
    background: #087cd6;
    width: 120px;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .nav-item:hover {
    .submenu {
      max-height: 300px;
      background: #d53b35;
      width: 120px;
      margin: 0;
      padding: 0;
    }
  }
}
</style>
